module.exports = __webpack_public_path__ + "static/media/spoonerism-task (3).f1c8d765.mp3";